module.exports = __webpack_public_path__ + "img/content1-3.67afa054.webp";